export default "__VITE_ASSET__ZgNSNmvH__"